import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F47s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      institucion_bancaria: "",
      fecha_de_contratacion: "",
      autorizacionno_de_decreto: "",
      fecha_de_vencimiento: "",
      objeto_del_prestamo: "",
      monto_original: "",
      ordinario: "",
      moratorio: "",
      comisiones: "",
      plazo: "",
      periodicidad_de_pago: "",
      fuente_de_pago: "",
      saldo_al_inicio_del_ejercicio: "",
      apertura_de_credito: "",
      amortizaciones: "",
      saldo_al_corte: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f47s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F47/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f47s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/47/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      institucion_bancaria: "",
      fecha_de_contratacion: "",
      autorizacionno_de_decreto: "",
      fecha_de_vencimiento: "",
      objeto_del_prestamo: "",
      monto_original: "",
      ordinario: "",
      moratorio: "",
      comisiones: "",
      plazo: "",
      periodicidad_de_pago: "",
      fuente_de_pago: "",
      saldo_al_inicio_del_ejercicio: "",
      apertura_de_credito: "",
      amortizaciones: "",
      saldo_al_corte: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      institucion_bancaria: row.institucion_bancaria,
      fecha_de_contratacion: row.fecha_de_contratacion,
      autorizacionno_de_decreto: row.autorizacionno_de_decreto,
      fecha_de_vencimiento: row.fecha_de_vencimiento,
      objeto_del_prestamo: row.objeto_del_prestamo,
      monto_original: row.monto_original,
      ordinario: row.ordinario,
      moratorio: row.moratorio,
      comisiones: row.comisiones,
      plazo: row.plazo,
      periodicidad_de_pago: row.periodicidad_de_pago,
      fuente_de_pago: row.fuente_de_pago,
      saldo_al_inicio_del_ejercicio: row.saldo_al_inicio_del_ejercicio,
      apertura_de_credito: row.apertura_de_credito,
      amortizaciones: row.amortizaciones,
      saldo_al_corte: row.saldo_al_corte,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      institucion_bancaria: row.institucion_bancaria,
      fecha_de_contratacion: row.fecha_de_contratacion,
      autorizacionno_de_decreto: row.autorizacionno_de_decreto,
      fecha_de_vencimiento: row.fecha_de_vencimiento,
      objeto_del_prestamo: row.objeto_del_prestamo,
      monto_original: row.monto_original,
      ordinario: row.ordinario,
      moratorio: row.moratorio,
      comisiones: row.comisiones,
      plazo: row.plazo,
      periodicidad_de_pago: row.periodicidad_de_pago,
      fuente_de_pago: row.fuente_de_pago,
      saldo_al_inicio_del_ejercicio: row.saldo_al_inicio_del_ejercicio,
      apertura_de_credito: row.apertura_de_credito,
      amortizaciones: row.amortizaciones,
      saldo_al_corte: row.saldo_al_corte,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      institucion_bancaria: row.institucion_bancaria,
      fecha_de_contratacion: row.fecha_de_contratacion,
      autorizacionno_de_decreto: row.autorizacionno_de_decreto,
      fecha_de_vencimiento: row.fecha_de_vencimiento,
      objeto_del_prestamo: row.objeto_del_prestamo,
      monto_original: row.monto_original,
      ordinario: row.ordinario,
      moratorio: row.moratorio,
      comisiones: row.comisiones,
      plazo: row.plazo,
      periodicidad_de_pago: row.periodicidad_de_pago,
      fuente_de_pago: row.fuente_de_pago,
      saldo_al_inicio_del_ejercicio: row.saldo_al_inicio_del_ejercicio,
      apertura_de_credito: row.apertura_de_credito,
      amortizaciones: row.amortizaciones,
      saldo_al_corte: row.saldo_al_corte,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      institucion_bancaria: this.state.institucion_bancaria,
      fecha_de_contratacion: this.state.fecha_de_contratacion,
      autorizacionno_de_decreto: this.state.autorizacionno_de_decreto,
      fecha_de_vencimiento: this.state.fecha_de_vencimiento,
      objeto_del_prestamo: this.state.objeto_del_prestamo,
      monto_original: this.state.monto_original,
      ordinario: this.state.ordinario,
      moratorio: this.state.moratorio,
      comisiones: this.state.comisiones,
      plazo: this.state.plazo,
      periodicidad_de_pago: this.state.periodicidad_de_pago,
      fuente_de_pago: this.state.fuente_de_pago,
      saldo_al_inicio_del_ejercicio: this.state.saldo_al_inicio_del_ejercicio,
      apertura_de_credito: this.state.apertura_de_credito,
      amortizaciones: this.state.amortizaciones,
      saldo_al_corte: this.state.saldo_al_corte,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F47", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      institucion_bancaria: this.state.institucion_bancaria,
      fecha_de_contratacion: this.state.fecha_de_contratacion,
      autorizacionno_de_decreto: this.state.autorizacionno_de_decreto,
      fecha_de_vencimiento: this.state.fecha_de_vencimiento,
      objeto_del_prestamo: this.state.objeto_del_prestamo,
      monto_original: this.state.monto_original,
      ordinario: this.state.ordinario,
      moratorio: this.state.moratorio,
      comisiones: this.state.comisiones,
      plazo: this.state.plazo,
      periodicidad_de_pago: this.state.periodicidad_de_pago,
      fuente_de_pago: this.state.fuente_de_pago,
      saldo_al_inicio_del_ejercicio: this.state.saldo_al_inicio_del_ejercicio,
      apertura_de_credito: this.state.apertura_de_credito,
      amortizaciones: this.state.amortizaciones,
      saldo_al_corte: this.state.saldo_al_corte,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F47/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F47/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeInstitucionBancaria = e => {
    this.setState({ institucion_bancaria: e.target.value });
  };

  onChangeFechaDeContratacion = e => {
    this.setState({ fecha_de_contratacion: e.target.value });
  };

  onChangeAutorizacionnoDeDecreto = e => {
    this.setState({ autorizacionno_de_decreto: e.target.value });
  };

  onChangeFechaDeVencimiento = e => {
    this.setState({ fecha_de_vencimiento: e.target.value });
  };

  onChangeObjetoDelPrestamo = e => {
    this.setState({ objeto_del_prestamo: e.target.value });
  };

  onChangeMontoOriginal = e => {
    this.setState({ monto_original: e.target.value });
  };

  onChangeOrdinario = e => {
    this.setState({ ordinario: e.target.value });
  };

  onChangeMoratorio = e => {
    this.setState({ moratorio: e.target.value });
  };

  onChangeComisiones = e => {
    this.setState({ comisiones: e.target.value });
  };

  onChangePlazo = e => {
    this.setState({ plazo: e.target.value });
  };

  onChangePeriodicidadDePago = e => {
    this.setState({ periodicidad_de_pago: e.target.value });
  };

  onChangeFuenteDePago = e => {
    this.setState({ fuente_de_pago: e.target.value });
  };

  onChangeSaldoAlInicioDelEjercicio = e => {
    this.setState({ saldo_al_inicio_del_ejercicio: e.target.value });
  };

  onChangeAperturaDeCredito = e => {
    this.setState({ apertura_de_credito: e.target.value });
  };

  onChangeAmortizaciones = e => {
    this.setState({ amortizaciones: e.target.value });
  };

  onChangeSaldoAlCorte = e => {
    this.setState({ saldo_al_corte: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"47"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "institucion_bancaria",
        text: "Institucion Bancaria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_contratacion",
        text: "Fecha De Contratacion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "autorizacionno_de_decreto",
        text: "Autorizacionno De Decreto",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_vencimiento",
        text: "Fecha De Vencimiento",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "objeto_del_prestamo",
        text: "Objeto Del Prestamo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "monto_original",
        text: "Monto Original",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "ordinario",
        text: "Ordinario",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "moratorio",
        text: "Moratorio",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "comisiones",
        text: "Comisiones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "plazo",
        text: "Plazo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "periodicidad_de_pago",
        text: "Periodicidad De Pago",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fuente_de_pago",
        text: "Fuente De Pago",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "saldo_al_inicio_del_ejercicio",
        text: "Saldo Al Inicio Del Ejercicio",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "apertura_de_credito",
        text: "Apertura De Credito",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "amortizaciones",
        text: "Amortizaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "saldo_al_corte",
        text: "Saldo Al Corte",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ESTADO DE LA DEUDA PÚBLICA</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 47 referente
                a estado de la deuda pública, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f47s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="47" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=47"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Institucion Bancaria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el nombre de la institución bancaria con la cual fue contraído el compromiso." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="institucion_bancaria"
                  value={this.state.institucion_bancaria}
                  onChange={this.onChangeInstitucionBancaria}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Contratacion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la fecha de contratación del compromiso." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_contratacion"
                  value={this.state.fecha_de_contratacion}
                  onChange={this.onChangeFechaDeContratacion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Autorizacionno De Decreto:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el número de decreto (Periódico Oficial) por el cual fue autorizado el crédito." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="autorizacionno_de_decreto"
                  value={this.state.autorizacionno_de_decreto}
                  onChange={this.onChangeAutorizacionnoDeDecreto}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Vencimiento:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Fecha en la que debe quedar liquidado el crédito correspondiente." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_vencimiento"
                  value={this.state.fecha_de_vencimiento}
                  onChange={this.onChangeFechaDeVencimiento}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Objeto Del Prestamo:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Describir el concepto de la justificación por el cual se adquiere el crédito." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="objeto_del_prestamo"
                  value={this.state.objeto_del_prestamo}
                  onChange={this.onChangeObjetoDelPrestamo}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Monto Original:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "El importe original de la deuda que se obtuvo, lo cual debe coincidir con lo plasmado en el contrato de apertura del crédito realizado por la institución bancaria." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="monto_original"
                  value={this.state.monto_original}
                  onChange={this.onChangeMontoOriginal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Ordinario:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la tasa de interés ordinario señalado en el contrato de apertura del crédito que corresponda al plazo pactado." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ordinario"
                  value={this.state.ordinario}
                  onChange={this.onChangeOrdinario}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Moratorio:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la tasa de interés moratorio señalado en el contrato de apertura del crédito que corresponda al plazo pactado." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="moratorio"
                  value={this.state.moratorio}
                  onChange={this.onChangeMoratorio}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Comisiones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la comisión generada en el periodo que se informa." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="comisiones"
                  value={this.state.comisiones}
                  onChange={this.onChangeComisiones}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Plazo:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el plazo en meses pactado en el contrato de apertura del crédito para cubrir el compromiso contraído." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="plazo"
                  value={this.state.plazo}
                  onChange={this.onChangePlazo}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Periodicidad De Pago:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la periodicidad de pago o fecha límite de realizar el mismo, ante la institución bancaria." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="periodicidad_de_pago"
                  value={this.state.periodicidad_de_pago}
                  onChange={this.onChangePeriodicidadDePago}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fuente De Pago:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Describir la fuente de pago, es decir, mencionar cual es el rubro con el que se va a cubrir el compomiso contraído." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="fuente_de_pago"
                  value={this.state.fuente_de_pago}
                  onChange={this.onChangeFuenteDePago}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Saldo Al Inicio Del Ejercicio:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el saldo al inicio del ejercicio que se tenía con la institución bancaria." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="saldo_al_inicio_del_ejercicio"
                  value={this.state.saldo_al_inicio_del_ejercicio}
                  onChange={this.onChangeSaldoAlInicioDelEjercicio}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Apertura De Credito:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el importe del nuevo crédito obtenido en el ejercicio, con la institución bancaria." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="apertura_de_credito"
                  value={this.state.apertura_de_credito}
                  onChange={this.onChangeAperturaDeCredito}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Amortizaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el importe de las amortizaciones del crédito en el ejercicio (el importe de pago que se ha acumulado durante el ejercicio)." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="amortizaciones"
                  value={this.state.amortizaciones}
                  onChange={this.onChangeAmortizaciones}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Saldo Al Corte:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el saldo a la fecha de corte, mismo que tiene que coincidir con lo plasmado en los estados financieros en el rubro de la deuda pública." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="saldo_al_corte"
                  value={this.state.saldo_al_corte}
                  onChange={this.onChangeSaldoAlCorte}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Comentarios que se consideren  pertinentes con respecto a la información señalada." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit} className="btn-ejecutar">
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Institucion Bancaria:
                    </Col>
                    <Col xs={10}>{this.state.institucion_bancaria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Contratacion:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_contratacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Autorizacionno De Decreto:
                    </Col>
                    <Col xs={10}>{this.state.autorizacionno_de_decreto}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Vencimiento:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_vencimiento}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Objeto Del Prestamo:
                    </Col>
                    <Col xs={10}>{this.state.objeto_del_prestamo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Monto Original:
                    </Col>
                    <Col xs={10}>{this.state.monto_original}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ordinario:
                    </Col>
                    <Col xs={10}>{this.state.ordinario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Moratorio:
                    </Col>
                    <Col xs={10}>{this.state.moratorio}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Comisiones:
                    </Col>
                    <Col xs={10}>{this.state.comisiones}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Plazo:
                    </Col>
                    <Col xs={10}>{this.state.plazo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Periodicidad De Pago:
                    </Col>
                    <Col xs={10}>{this.state.periodicidad_de_pago}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fuente De Pago:
                    </Col>
                    <Col xs={10}>{this.state.fuente_de_pago}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Saldo Al Inicio Del Ejercicio:
                    </Col>
                    <Col xs={10}>{this.state.saldo_al_inicio_del_ejercicio}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Apertura De Credito:
                    </Col>
                    <Col xs={10}>{this.state.apertura_de_credito}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Amortizaciones:
                    </Col>
                    <Col xs={10}>{this.state.amortizaciones}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Saldo Al Corte:
                    </Col>
                    <Col xs={10}>{this.state.saldo_al_corte}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>
                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F47s;
